import { render, staticRenderFns } from "./add-edit.vue?vue&type=template&id=b68c6d18&scoped=true&"
import script from "./add-edit.vue?vue&type=script&lang=js&"
export * from "./add-edit.vue?vue&type=script&lang=js&"
import style0 from "./add-edit.vue?vue&type=style&index=0&id=b68c6d18&prod&lang=scss&"
import style1 from "./add-edit.vue?vue&type=style&index=1&id=b68c6d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68c6d18",
  null
  
)

export default component.exports